import cookie from './cookie'; //cookie相关
import format from './format'; //格式化相关
import log from './log'; //组件错误提示相关，参考next

export default { cookie, format, log }


// WEBPACK FOOTER //
// ./src/base/index.js